export const MAX_2B_ASN = 65536;

export type AsnFormat = 'asplain' | 'asdot';

export const formatAsn = (
  asn: number | null,
  format: AsnFormat,
): string | null => {
  if (asn === null) {
    return null;
  }
  if (asn < MAX_2B_ASN || format === 'asplain') {
    return asn.toString();
  }
  const first = Math.floor(asn / MAX_2B_ASN);
  return `${first}.${asn - first * MAX_2B_ASN}`;
};
